//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

export const PATH = 'packageLogs'
export const OPEN_PACKAGE_LOGS = `${PATH}/OPEN_PACKAGE_LOGS`
export const SET_START_DATE = `${PATH}/SET_START_DATE`
export const SET_END_DATE = `${PATH}/SET_END_DATE`
